import React from 'react'
import { Notification, toast } from 'components/ui'

export const joinArray = (array) => {
    return array.join(';')
}

export const removeSpecialSymbols = (str) => {
    if (!str) return ''
    return str.replace(/[^a-zA-Z0-9]/g, '')
}

export const showNotification = (type, title, message) => {
    toast.push(
        <Notification title={title} type={type}>
            {message}
        </Notification>
    )
}

export const formatNumber = ({ value, decimalPlaces, currency }) => {
    if (!value) return '0'
    const number = Number(value)
    const parts = number.toFixed(decimalPlaces).split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    if (currency) {
        return `${currency} ${parts.join('.')}`
    }
    return parts.join('.')
}

export function debounce(action, timer = 2000) {
    let timeoutId

    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
            action()
        }, timer)
    }
}

export const removeNonNumeric = (value) => {
    return value.replace(/[^0-9]/g, '')
}
